export const environment = {
  production: false,
  name: 'staging',
  apiUrl: 'https://api-portal-staging.carblip.com/api',
  requestTimeout: 15000,
  weburl: 'https://portal-staging.carblip.com'
};


